export default "__VITE_ASSET__biNrMBzl__"